import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="relative w-full bg-gradient-to-br from-[#e9f2fc] via-[#dbeafb] to-[#d0e7f9] overflow-hidden">
      <div
        className="absolute inset-0 bg-grid [mask-image:radial-gradient(ellipse_at_center,#000_30%,transparent_75%)]"
        aria-hidden="true"
      ></div>
      <div
        className="absolute -top-32 -left-24 w-[34rem] h-[34rem] rounded-full bg-textBlue/10 blur-[120px]"
        aria-hidden="true"
      ></div>
      <div
        className="absolute top-1/3 -right-32 w-[30rem] h-[30rem] rounded-full bg-primaryBlue/10 blur-[120px]"
        aria-hidden="true"
      ></div>

      <div className="relative container-page pt-40 tablet:pt-36 mobile:pt-32 pb-24 tablet:pb-20">
        <div className="max-w-3xl animate-enter">
          <span className="kicker mb-6">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-textBlue" aria-hidden="true"></span>
            {t("hero.subtitle")}
          </span>

          <h1 className="text-6xl tablet:text-5xl mobile:text-4xl font-semibold tracking-[-0.02em] leading-[1.05] text-black mb-5">
            {t("hero.title")}
          </h1>

          <p className="text-2xl tablet:text-xl font-semibold text-textBlue leading-snug tracking-[-0.01em] max-w-xl mb-5">
            {t("hero.tagline")}
          </p>

          <p className="text-base text-gray-600 leading-relaxed max-w-[60ch] mb-8">
            {t("hero.description")}
          </p>

          <div className="flex items-center gap-4 flex-wrap">
            <Link
              to="/solutions"
              className="group inline-flex items-center gap-2 bg-textBlue text-white text-sm font-medium px-6 py-3 rounded-full hover:bg-textBlueDark transition-colors duration-200 no-underline focus-visible:ring-2 focus-visible:ring-primaryBlue focus-visible:ring-offset-2"
            >
              {t("hero.button")}
              <ArrowRight
                className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5"
                aria-hidden="true"
              />
            </Link>
            <span className="text-sm text-gray-600">
              {t("hero.trusted")}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
